import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcFilters = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M13 5h8a1 1 0 1 1 0 2h-8V5Zm-4 6h12a1 1 0 1 1 0 2H9v-2Zm12 6h-4v2h4a1 1 0 1 0 0-2Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M9.126 7a4.007 4.007 0 0 1 0-2H3a1 1 0 0 0 0 2h6.126Zm-4 6a4.007 4.007 0 0 1 0-2H3a1 1 0 1 0 0 2h2.126Zm8 6a4.01 4.01 0 0 1 0-2H3a1 1 0 1 0 0 2h10.126Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M19 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM15 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-4 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcFilters");

export { IcFilters };
//# sourceMappingURL=ic-filters.js.map
